import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { EventTimer } from '../Countdown/EventTimer'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import CallService from '../../services/callService'
import { WithCountdown } from '../../hooks/use-countdown'
import { useEventById } from '../../hooks/use-event-by-id'
import { ReadEvent } from '../../schemas/event-schemas'

const StartEventUpdatedSchema = ReadEvent.pick({ secondsUntilStart: true })

export function StartEventCountdown() {
  const { t } = useTranslation()
  const { data: event, isLoading, updateStartAtEvent } = useEventById()
  const { postHogTrackEvent } = usePostHogAnalytics()

  const onStartEventUpdated = (payload) => {
    const result = StartEventUpdatedSchema.safeParse(payload)
    if (result.success) {
      updateStartAtEvent(result.data)
    } else {
      console.error('Invalid payload for startEventUpdated:', result.error)
    }
  }

  useEffect(() => {
    CallService.setStartEventCountdownMessageHandler(onStartEventUpdated)
  }, [])

  if (isLoading || event.secondsUntilStart === null || event.secondsUntilStart === 0) return null

  return (
    <WithCountdown
      finishAt={event.secondsUntilStart}
      onFinish={() => {
        updateStartAtEvent(0)
        postHogTrackEvent('post-counter-event-entry')
      }}
    >
      <EventTimer title={t('countdown.startEventTimerHeader')} finishAt={event.secondsUntilStart} />
    </WithCountdown>
  )
}
